module.exports = __webpack_public_path__ + "static/media/0-items.a02e3e9a.png";